import { render, staticRenderFns } from "./ReportDeliveryDevolution.vue?vue&type=template&id=1ccbcaa8&"
import script from "./ReportDeliveryDevolution.vue?vue&type=script&lang=js&"
export * from "./ReportDeliveryDevolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports